import { Module } from '../models/module.model';

export class UpdateModuleContent {
    static readonly type = '[Module] UpdateModuleContent';

    constructor(public payload: Module) {}
}
